import React from 'react';

import {type RouteData} from '../types';
import {
  AGENT_PATHS,
  ENTITY_LAUNCH_PATHS,
  LAUNCH_PATH,
  PROJECT_LAUNCH_TAB_PATH,
  QUEUE_PATHS,
} from './launchPaths';

export const LAUNCH_ROUTES_DATA: RouteData[] = [
  {
    additionalProps: {
      allowIframes: false,
      skipTracking: true, // HomePageWithData handles tracking via HOME_NESTED_ROUTES
    },
    exact: true,
    isPrivateRoute: false,
    path: ENTITY_LAUNCH_PATHS,
    RouteComponent: React.lazy(
      () => import('../../pages/HomePage/HomePageWithData')
    ),
  },
  {
    additionalProps: {
      allowIframes: true,
      datadogViewName: 'Agent',
    },
    exact: true,
    isPrivateRoute: false,
    path: AGENT_PATHS,
    RouteComponent: React.lazy(
      () => import('../../components/Launch/LaunchContent')
    ),
  },
  {
    additionalProps: {
      allowIframes: true,
      datadogViewName: 'Queue',
    },
    exact: true,
    isPrivateRoute: false,
    path: QUEUE_PATHS,
    RouteComponent: React.lazy(
      () => import('../../components/Launch/LaunchContent')
    ),
  },
  {
    exact: true,
    path: PROJECT_LAUNCH_TAB_PATH,
    redirect: LAUNCH_PATH,
  },
];
